import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'

import {
  Button,
  FormElement,
  InputText,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'

import {
  editBeeSavedRowCancelCallback,
  editBeeSavedRowConfirmCallback
} from 'Pages/Campaign/recoil/callbacks/beeSavedRowsCallback'
import { modalBeeSavedRowMetadataState } from 'Pages/Campaign/recoil/state/beeSavedRows'
import { useIntl } from 'react-intl'

export const ModalBeeSavedRow = () => {
  const intl = useIntl()
  const { show, metadata } = useRecoilValue(modalBeeSavedRowMetadataState)

  const setState = useSetRecoilState(modalBeeSavedRowMetadataState)

  const handleConfirm = useRecoilCallback(editBeeSavedRowConfirmCallback, [])

  const handleCancel = useRecoilCallback(editBeeSavedRowCancelCallback, [])

  const handleNameChange = ({ target: { value } }) => {
    setState(({ metadata, ...prev }) => ({
      ...prev,
      metadata: {
        ...metadata,
        name: value
      }
    }))
  }

  return (
    <Modal show={show} onClose={handleCancel}>
      <ModalHead
        title={intl.formatMessage({ id: 'Load.Bee.SaveRowModalTitle' })}
      />
      <ModalBody>
        <FormElement
          label={intl.formatMessage({ id: 'Load.Bee.SaveRowModalNameLabel' })}
          hint={intl.formatMessage({ id: 'Load.Bee.SaveRowModalNameHint' })}
        >
          <InputText
            placeHolder={intl.formatMessage({
              id: 'Load.Bee.SaveRowModalNamePlaceholder'
            })}
            value={metadata.name}
            onChange={handleNameChange}
            maxlength='100'
          />
        </FormElement>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='secondary'
          onClick={handleCancel}
          data-mu-test='modal-saved-rows-btn-cancel'
        >
          {intl.formatMessage({
            id: 'Load.MailupCommon.Cancel'
          })}
        </Button>
        <Button
          kind='primary'
          onClick={handleConfirm}
          disabled={!metadata.name}
          data-mu-test='modal-saved-rows-btn-save'
        >
          {intl.formatMessage({
            id: 'Load.Common.Save'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
